import { useCallback, useMemo } from "react";
import { CustomModal } from "../../../../lib/CustomModal";
import { FormItems } from "./FormItems";

type CloseModalProps = {
  taskId: string | undefined;
  setTaskId: React.Dispatch<React.SetStateAction<string | undefined>>;
  reload: () => void;
};

export const CloseModal = ({ taskId, setTaskId, reload }: CloseModalProps) => {
  const open: boolean = useMemo(() => !!taskId, [taskId]);

  const setOpen = useCallback(
    (_: boolean) => setTaskId(undefined),
    [setTaskId],
  );

  const close = useCallback(() => setTaskId(undefined), [setTaskId]);

  return (
    <CustomModal
      isModalOpen={open}
      setIsModalOpen={setOpen}
      titleText="Close Task"
      headerClass="processing-print-modal--header"
      modalClass="processing-print-modal close-task-modal"
      width={500}
      destroyOnClose
    >
      <FormItems id={taskId || ""} close={close} reload={reload} />
    </CustomModal>
  );
};
